var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh","display":"flex","flex-direction":"row","justify-content":"center","justify-items":"center","align-items":"center"}},[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}})])
}]

export { render, staticRenderFns }